import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";

const PromoTemplateIdFilterModal = ({
  templateIdFilterModalVisible,
  setTemplateIdFilterModalVisible,
  sendDataToOrdersPageFromFilter,
  OrderTemplateId,
  status,
  text,
}) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState([]);

  useEffect(() => {
    // Update localSelectedStatus when selectedStatus changes
    setSelectedTemplateId(OrderTemplateId.map((item) => item.id));
  }, [OrderTemplateId]);

  const handleTemplateIdToggle = (templateId) => {
    const updatedTemplateId = [...selectedTemplateId];

    if (updatedTemplateId.includes(templateId)) {
      // Remove status if already selected
      updatedTemplateId.splice(updatedTemplateId.indexOf(templateId), 1);
    } else {
      // Add status if not selected
      updatedTemplateId.push(templateId);
    }

    setSelectedTemplateId(updatedTemplateId);
  };
  const handleConfirmPickup = () => {
    // Close the modal
    setTemplateIdFilterModalVisible(false);
    sendDataToOrdersPageFromFilter(
      selectedTemplateId.length > 0 ? selectedTemplateId : "ALL"
    );
  };

  const handleModalClose = () => {
    setTemplateIdFilterModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={templateIdFilterModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!templateIdFilterModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                Select TemplateId
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
                {OrderTemplateId?.map((templateIdItem) => (
                  <div
                    key={templateIdItem}
                    className="flex flex-1 justify-content-between my-1"
                  >
                    <p className="text-xl font-medium">
                      {templateIdItem.templateName.replace(/_/g, " ")}
                    </p>
                    <div>
                      <Checkbox
                        checked={selectedTemplateId.includes(
                          templateIdItem.id
                        )}
                        size="20" // Increased size
                        color={
                          selectedTemplateId.includes(templateIdItem.id)
                            ? "#00A3FF"
                            : "#C1C9D3"
                        }
                        onClick={() =>
                          handleTemplateIdToggle(templateIdItem)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <Button
              onClick={handleConfirmPickup}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Filter
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default PromoTemplateIdFilterModal;
